import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";

export type MorphemeDetailsTileStatsSectionGate = Tagged<
  { levelLabel: string | null; rankLabel: string | null },
  "MorphemeDetailsTileStatsSectionGate"
>;

/** Whether a details tile shows its stats row. `null` is the designed hidden state: neither a level nor a rank. */
export function getMorphemeDetailsTileStatsSectionGate({
  levelLabel,
  rankLabel,
}: {
  levelLabel: string | null;
  rankLabel: string | null;
}): MorphemeDetailsTileStatsSectionGate | null {
  if (levelLabel === null && rankLabel === null) {
    return null;
  }
  return createGate<MorphemeDetailsTileStatsSectionGate>({ levelLabel, rankLabel });
}
